/**
 * EdgeTooltip — Positioned tooltip on edge hover.
 */

import React from 'react';
import { RELATIONSHIP_TYPES } from './constants';
import type { IntegrationEdge } from '../../services/integration-map-api';

interface Props {
  edge: IntegrationEdge;
  x: number;
  y: number;
}

const EdgeTooltip: React.FC<Props> = ({ edge, x, y }) => {
  const type = RELATIONSHIP_TYPES[edge.relationshipType as keyof typeof RELATIONSHIP_TYPES]
    || RELATIONSHIP_TYPES.custom;

  return (
    <div
      style={{
        position: 'absolute',
        left: x + 12,
        top: y - 10,
        background: 'var(--bg-primary, #1e293b)',
        border: '1px solid var(--border-primary, rgba(255,255,255,0.1))',
        borderRadius: '8px',
        padding: '12px',
        pointerEvents: 'none',
        zIndex: 1000,
        maxWidth: '280px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: '4px', color: 'var(--text-primary, #e2e8f0)' }}>
        {edge.label}
      </div>
      <div style={{ fontSize: '12px', color: type.color }}>
        {type.label} &middot; Weight: {edge.weight}/10
      </div>
      {edge.description && (
        <div style={{ fontSize: '12px', marginTop: '4px', color: 'var(--text-secondary, #94a3b8)' }}>
          {edge.description}
        </div>
      )}
      {edge.isCritical && (
        <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>
          ⚠ Critical relationship
        </div>
      )}
    </div>
  );
};

export default EdgeTooltip;
